import React, { useEffect } from 'react';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useSubscriptionTracking } from 'Shared/tracking/use-subscription-tracking';

// Types
import { Feature } from 'Shared/types/Organization.type';
import { Illustrations } from 'Wpds/components/illustration';

// Components
import { WpButton } from 'Wpds/components/button';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

const ReviewsBlocker = () => {
  const { intercomContactSalesEventName } = useApp();
  const { trackViewedFeatureGate } = useSubscriptionTracking();

  useEffect(() => {
    trackViewedFeatureGate({ feature: Feature.reviews });
  }, []);

  return (
    <EmptyStateContainer
      title="Actionable 360 feedback, at all levels"
      subTitle="In Perform, kicking off a 360 feedback cycle for multiple team members takes less than 5 minutes. Generate a review summary with the help of AI, then fine-tune the messaging to your liking."
      button={<WpButton dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>Schedule a call </WpButton>}
      image={Illustrations.helping_hand_climbing_mountain_white_bg}
    />
  );
};

export default ReviewsBlocker;
